module.exports = __webpack_public_path__ + "f6e3733c70db8db8048d1211ea237a42.svg";